import { useAutoAnimate } from "@formkit/auto-animate/react"
import { useContext, useState } from "react"
import { Link, useNavigate } from "react-router-dom"
import { ERRORTYPES } from "../../config"
import { getEnvConfig } from "../../env"
import { Context } from "../../store/store"
import Alert from "../elements/Alert"
import Spinner from "../elements/Spinner"
import PreFillForm from "./PreFillForm"
import { useForm } from "react-hook-form"
import axios from "axios"
import clsx from "clsx"
import ElemInput from "../elements/Input"
import ElemCheckbox from "../elements/Checkbox"

const Form = () => {
	const { globalState } = useContext(Context)
	const navigate = useNavigate()
	const [formError, setFormError] = useState<ERRORTYPES | null>(null)
	const [isLoading, setIsLoading] = useState<boolean>(false)
	const [animationRef] = useAutoAnimate<HTMLDivElement>()

	const {
		register,
		handleSubmit,
		setError,
		setValue,
		watch,
		reset,
		formState: { errors },
	} = useForm({})

	function handleFormSubmit(data) {
		if (!globalState.receiptReference) {
			setFormError(ERRORTYPES.UPLOADSMISSING)
			return
		}

		setIsLoading(true)
		const env = getEnvConfig()

		axios
			.post(env.apibase + "order.php?cv=" + Date.now(), {
				...data,
				receiptDataEntries: globalState.receiptReference,
			})
			.then(res => {
				if (res.data.externalIdentifier) {
					try {
						// eslint-disable-next-line
						let dataLayer = window["dataLayer"] || []
						dataLayer.push({
							event: "form-submit",
							"form-name": "particpate",
							"form-submit": false,
							field_error: "send",
						})
					} catch (e) {}

					navigate("/danke")
				} else {
					setFormError(ERRORTYPES.SERVER)
					try {
						// eslint-disable-next-line
						let dataLayer = window["dataLayer"] || []
						dataLayer.push({
							event: "form-submit",
							"form-name": "participate",
							"form-submit": true,
							package: globalState.package,
						})
					} catch (e) {}
				}
			})
			.catch(error => {
				setFormError(ERRORTYPES.SERVER)
			})
			.finally(() => {
				setIsLoading(false)
			})
	}

	return (
		<form
			onSubmit={handleSubmit(handleFormSubmit)}
			noValidate={true}
			className="mx-auto max-w-[794px]  w-full pt-[4px] "
		>
			<div className="  px-4 sm:px-[80px] pt-[17px] sm:pt-[40px] grid grid-cols-1 gap-6">
				{/* <PreFillForm setValue={setValue} /> */}
				<div className="grid sm:grid-cols-2 grid-cols-1 gap-4">
					<ElemInput
						label={"Vorname *"}
						hasError={errors.firstName}
						errMsg={"Bitte Vorname angeben"}
						value={watch("firstName", false)}
						required={true}
					>
						<input
							{...register("firstName", {
								required: true,
								minLength: 1,
								maxLength: 30,
								pattern:
									/^(?!mailto:|https:\/\/|http:\/\/|ftp:\/\/|sftp:\/\/)[a-zA-ZÀ-ÖØ-öø-ÿu~áçíóôąćČčđėěğīİıĶŁłńŕśŞşŠšūźżŽž̈БКМСавгжиклнорстьіẞ–—\-\s]+$/,
							})}
							type="text"
							minLength={1}
							maxLength={30}
							autoComplete="off"
							className={clsx("peer inputElem", errors.firstName && "inputElemErr js-formerror")}
						/>
					</ElemInput>
					<ElemInput
						label={"Nachname *"}
						hasError={errors.lastName}
						errMsg={"Bitte Nachname angeben"}
						value={watch("lastName", false)}
						required={true}
					>
						<input
							{...register("lastName", {
								required: true,
								minLength: 1,
								maxLength: 30,
								pattern:
									/^(?!mailto:|https:\/\/|http:\/\/|ftp:\/\/|sftp:\/\/)[a-zA-ZÀ-ÖØ-öø-ÿu~áçíóôąćČčđėěğīİıĶŁłńŕśŞşŠšūźżŽž̈БКМСавгжиклнорстьіẞ–—\-\s]+$/,
							})}
							type="text"
							minLength={1}
							maxLength={30}
							autoComplete="off"
							className={clsx("peer inputElem", errors.lastName && "inputElemErr js-formerror")}
						/>
					</ElemInput>
				</div>

				<div className="grid sm:grid-cols-[1fr_120px] grid-cols-1 gap-4">
					<ElemInput
						label={"Straße *"}
						hasError={errors.street}
						errMsg={"Bitte Straße angeben"}
						value={watch("street", false)}
						required={true}
					>
						<input
							{...register("street", {
								required: true,
								minLength: 1,
								maxLength: 240,
								pattern:
									/^[a-zA-ZÀ-ÖØ-öø-ÿ0-9 "#&()*+,-.\\\/:?@_u|~áçíóôąćČčđėěğīİıĶŁłńŕśŞşŠšūźżŽž̈БКМСавгжиклнорстьіẞ–—‘’'']+$/,
							})}
							type="text"
							minLength={1}
							maxLength={240}
							autoComplete="off"
							className={clsx("peer inputElem", errors.street && "inputElemErr js-formerror")}
						/>
					</ElemInput>
					<ElemInput
						label={"Hausnummer *"}
						hasError={errors.houseNr}
						errMsg={"Bitte Hausnummer angeben"}
						value={watch("houseNr", false)}
						required={true}
					>
						<input
							{...register("houseNr", {
								required: true,
								minLength: 1,
								maxLength: 14,
								pattern:
									/^[a-zA-ZÀ-ÖØ-öø-ÿ0-9 "#&()*+,-.\\\/:?@_u|~áçíóôąćČčđėěğīİıĶŁłńŕśŞşŠšūźżŽž̈БКМСавгжиклнорстьіẞ–—‘’'']+$/,
							})}
							type="text"
							minLength={1}
							maxLength={14}
							autoComplete="off"
							className={clsx("peer inputElem", errors.houseNr && "inputElemErr js-formerror")}
						/>
					</ElemInput>
				</div>

				<div className="grid sm:grid-cols-[120px_1fr] grid-cols-1 gap-4">
					<ElemInput
						label={"Postleitzahl *"}
						hasError={errors.zip}
						errMsg={"Bitte Postleitzahl angeben"}
						value={watch("zip", false)}
						required={true}
					>
						<input
							{...register("zip", {
								required: true,
								pattern: /^\d{5}$/,
								minLength: 5,
								maxLength: 5,
							})}
							type="text"
							minLength={5}
							maxLength={5}
							autoComplete="off"
							className={clsx("peer inputElem", errors.zip && "inputElemErr js-formerror")}
						/>
					</ElemInput>
					<ElemInput
						label={"Ort *"}
						hasError={errors.city}
						errMsg={"Bitte Ort angeben"}
						value={watch("city", false)}
						required={true}
					>
						<input
							{...register("city", {
								required: true,
								minLength: 1,
								maxLength: 240,
								pattern:
									/^[a-zA-ZÀ-ÖØ-öø-ÿ0-9 "#&()*+,-.\\\/:?@_u|~áçíóôąćČčđėěğīİıĶŁłńŕśŞşŠšūźżŽž̈БКМСавгжиклнорстьіẞ–—‘’'']+$/,
							})}
							type="text"
							minLength={1}
							maxLength={240}
							autoComplete="off"
							className={clsx("peer inputElem", errors.city && "inputElemErr js-formerror")}
						/>
					</ElemInput>
				</div>

				<div className="grid sm:grid-cols-[160px_1fr] grid-cols-1 gap-4">
					<ElemInput
						label={"Geburtstag *"}
						hasError={errors.birthday}
						errMsg={"Eine Teilnahme ist erst ab 18 Jahren möglich"}
						value={watch("birthday", false)}
						required={true}
					>
						<input
							{...register("birthday", {
								required: true,
								validate: value => {
									const today = new Date()
									const birthDate = new Date(value)
									let age = today.getFullYear() - birthDate.getFullYear()
									const m = today.getMonth() - birthDate.getMonth()
									if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
										age--
									}
									return age >= 18
								},
							})}
							type="date"
							autoComplete="off"
							className={clsx("peer inputElem", errors.birthday && "inputElemErr js-formerror")}
						/>
					</ElemInput>
					<ElemInput
						label={"E-Mail *"}
						hasError={errors.email}
						errMsg={"Bitte E-Mail angeben"}
						value={watch("email", false)}
						required={true}
					>
						<input
							{...register("email", { required: true })}
							type="email"
							autoComplete="off"
							className={clsx("peer inputElem", errors.email && "inputElemErr js-formerror")}
						/>
					</ElemInput>
				</div>
			</div>

			<div className=" mt-5 sm:mt-9 px-4">
				<p className="font-AcuminWide  text-[13px]  text-center ">
					Teilnahme ab 18 Jahren. Die Gewinner werden in den ersten <br className="hidden sm:inline-block" />
					zwei Wochen nach Teilnahmeschluss ermittelt.
				</p>
				<div className="max-w-[450px] mx-auto grid grid-cols-1 gap-3 pt-7">
					<ElemCheckbox
						hasError={errors.optInTerms}
						errMsg={"Bitte akzeptiere die Teilnahmebedingungen."}
						trackingOption={[{ eventname: "double_opt_in_confirmed " }]}
						label={
							<>
								Ich habe die{" "}
								<Link to={"/teilnahmebedingungen"} className="underline text-white">
									Teilnahmebedingungen
								</Link>{" "}
								gelesen und akzepterie diese.*
							</>
						}
					>
						<input
							{...register("optInTerms", { required: true })}
							type="checkbox"
							className="w-1 h-1 opacity-0 absolute peer"
						/>
					</ElemCheckbox>
					<ElemCheckbox
						hasError={errors.optInPrivacy}
						errMsg={"Bitte akzeptiere die Datenschutzerklärung."}
						trackingOption={[{ eventname: "double_opt_in_confirmed " }]}
						label={
							<>
								Ich habe die{" "}
								<a
									href={"https://wilkinsonsword.de/policies/privacy-policy"}
									className="underline text-white"
									target="_blank"
								>
									Datenschutzerklärung
								</a>{" "}
								gelesen und akzepterie diese.*
							</>
						}
					>
						<input
							{...register("optInPrivacy", { required: true })}
							type="checkbox"
							className="w-1 h-1 opacity-0 absolute peer"
						/>
					</ElemCheckbox>

					<p className="font-AcuminWide text-black text-[14px] text-center">* Pflichtfeld</p>
				</div>
			</div>
			<svg
				className="block sm:hidden mx-auto"
				width="58"
				height="58"
				viewBox="0 0 58 58"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<mask id="mask0_152_701" maskUnits="userSpaceOnUse" x="0" y="0" width="57" height="58">
					<path
						d="M56.9612 29.0259L37.5091 57.1903L0.0642597 28.1945L19.5164 0.0301268L56.9612 29.0259Z"
						fill="white"
					/>
				</mask>
				<g mask="url(#mask0_152_701)">
					<path
						d="M49.6797 34.7557C49.409 34.4285 48.9756 34.3076 48.6083 34.4579L43.3957 36.553C42.7155 28.2481 38.8567 19.7319 32.2038 11.7829C26.9211 5.46766 21.8049 1.80248 21.5322 1.63225L20.0596 0.711831C19.6071 0.427856 19.1052 0.545486 18.8535 1.00521L17.985 2.59296C17.7797 2.97093 17.8261 3.44669 18.136 3.76848C18.2652 3.90431 30.9401 17.4063 31.9809 36.6068L25.4977 35.0382C25.1329 34.9501 24.7556 35.0927 24.5449 35.4051C24.3342 35.7175 24.3281 36.1372 24.5293 36.4771L30.8695 47.2267L36.4928 56.3217C36.5761 56.4578 36.6901 56.5716 36.8182 56.6503C36.9627 56.7419 37.1293 56.7942 37.2991 56.7978C37.6242 56.8041 37.9193 56.6337 38.0869 56.3543L43.2171 47.5322L49.7934 35.8972C49.9938 35.541 49.9471 35.0804 49.6797 34.7557Z"
						fill="#FFF079"
					/>
				</g>
			</svg>

			{formError && <Alert className={"my-4 font-bold text-errorred"}>{formError}</Alert>}
			<div className="pb-2 pt-2 text-center" ref={animationRef}>
				<svg
					className="absolute left-1/2 -top-4 ml-[143px] hidden md:block"
					width="82"
					height="84"
					viewBox="0 0 82 84"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<mask id="mask0_43_496" maskUnits="userSpaceOnUse" x="0" y="0" width="82" height="84">
						<path d="M38.5136 83.5385L0 52.1126L42.5222 0L81.0358 31.4259L38.5136 83.5385Z" fill="white" />
					</mask>
					<g mask="url(#mask0_43_496)">
						<path
							d="M30.8449 72.2593C31.3171 71.8945 31.5083 71.2696 31.316 70.7146L28.6391 62.8426C40.3163 62.6794 52.4486 57.8658 63.9253 48.8886C73.043 41.7607 78.4371 34.6105 78.6894 34.2269L80.0534 32.1553C80.4741 31.5187 80.3343 30.7693 79.7024 30.3531L77.5198 28.9167C77.0001 28.5769 76.3308 28.5972 75.8642 29.0203C75.6673 29.1965 56.1046 46.4649 29.1341 46.0607L31.6571 36.6902C31.7989 36.1629 31.6179 35.5941 31.1904 35.253C30.7629 34.9118 30.1747 34.8606 29.6882 35.122L14.3007 43.3576L1.26894 50.7061C1.07391 50.8149 0.908639 50.9709 0.791873 51.1512C0.656358 51.3545 0.57471 51.5941 0.561124 51.8433C0.536088 52.3204 0.76023 52.7713 1.14348 53.0457L13.2556 61.4743L29.2388 72.3115C29.7282 72.6419 30.3763 72.6196 30.8449 72.2593Z"
							fill="#FFF079"
						/>
					</g>
				</svg>

				<button type="submit" className="btn btn-yellow" disabled={isLoading ? true : undefined}>
					{isLoading && <Spinner />}
					Jetzt teilnehmen
				</button>
			</div>
		</form>
	)
}

export default Form
